export const getTotalYearGrossMarginYear1 = (value) => {
  return {
    type: "GET_TOTAL_YEAR_GROSS_MARGIN_YEAR_1",
    payload: value,
  };
};
export const getTotalYearGrossMarginYear2 = (value) => {
  return {
    type: "GET_TOTAL_YEAR_GROSS_MARGIN_YEAR_2",
    payload: value,
  };
};
export const getTotalYearGrossMarginYear3 = (value) => {
  return {
    type: "GET_TOTAL_YEAR_GROSS_MARGIN_YEAR_3",
    payload: value,
  };
};
